import React, { useState, useEffect } from 'react';
import { Menu, X, Coffee } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav data-component-path="client/src/components/Navbar.jsx" data-component-line="26:5" data-component-id="client/src/components/Navbar.jsx:26:5" 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-charcoal/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div data-component-path="client/src/components/Navbar.jsx" data-component-line="31:7" data-component-id="client/src/components/Navbar.jsx:31:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Navbar.jsx" data-component-line="32:9" data-component-id="client/src/components/Navbar.jsx:32:9" className="flex items-center justify-between h-20">
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="33:11" data-component-id="client/src/components/Navbar.jsx:33:11" className="flex items-center gap-3">
            <Coffee data-component-path="client/src/components/Navbar.jsx" data-component-line="34:13" data-component-id="client/src/components/Navbar.jsx:34:13" className="w-8 h-8 text-copper flex-shrink-0" />
            <span data-component-path="client/src/components/Navbar.jsx" data-component-line="35:13" data-component-id="client/src/components/Navbar.jsx:35:13" className="hero-title text-2xl text-cream">
              The Ember & Oak
            </span>
          </div>

          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="40:11" data-component-id="client/src/components/Navbar.jsx:40:11" className="hidden md:flex items-center gap-8">
            <button data-component-path="client/src/components/Navbar.jsx" data-component-line="41:13" data-component-id="client/src/components/Navbar.jsx:41:13" 
              onClick={() => scrollToSection('menu')}
              className="text-cream hover:text-copper transition-colors duration-200 font-medium"
            >
              Menu
            </button>
            <button data-component-path="client/src/components/Navbar.jsx" data-component-line="47:13" data-component-id="client/src/components/Navbar.jsx:47:13" 
              onClick={() => scrollToSection('contact')}
              className="text-cream hover:text-copper transition-colors duration-200 font-medium"
            >
              Contact
            </button>
            <button data-component-path="client/src/components/Navbar.jsx" data-component-line="53:13" data-component-id="client/src/components/Navbar.jsx:53:13" 
              onClick={() => scrollToSection('contact')}
              className="h-11 px-6 bg-copper text-white rounded-lg hover:bg-copper/90 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 focus:ring-4 focus:ring-copper/50"
            >
              Reserve Table
            </button>
          </div>

          <button data-component-path="client/src/components/Navbar.jsx" data-component-line="62:11" data-component-id="client/src/components/Navbar.jsx:62:11" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-cream p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            {isMobileMenuOpen ? (
              <X data-component-path="client/src/components/Navbar.jsx" data-component-line="67:15" data-component-id="client/src/components/Navbar.jsx:67:15" className="w-6 h-6" />
            ) : (
              <Menu data-component-path="client/src/components/Navbar.jsx" data-component-line="69:15" data-component-id="client/src/components/Navbar.jsx:69:15" className="w-6 h-6" />
            )}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="76:11" data-component-id="client/src/components/Navbar.jsx:76:11" className="md:hidden py-4 border-t border-white/10">
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="77:13" data-component-id="client/src/components/Navbar.jsx:77:13" className="flex flex-col gap-4">
              <button data-component-path="client/src/components/Navbar.jsx" data-component-line="78:15" data-component-id="client/src/components/Navbar.jsx:78:15" 
                onClick={() => scrollToSection('menu')}
                className="text-cream hover:text-copper transition-colors duration-200 font-medium text-left"
              >
                Menu
              </button>
              <button data-component-path="client/src/components/Navbar.jsx" data-component-line="84:15" data-component-id="client/src/components/Navbar.jsx:84:15" 
                onClick={() => scrollToSection('contact')}
                className="text-cream hover:text-copper transition-colors duration-200 font-medium text-left"
              >
                Contact
              </button>
              <button data-component-path="client/src/components/Navbar.jsx" data-component-line="90:15" data-component-id="client/src/components/Navbar.jsx:90:15" 
                onClick={() => scrollToSection('contact')}
                className="h-11 px-6 bg-copper text-white rounded-lg hover:bg-copper/90 transition-all duration-200 shadow-md flex items-center justify-center gap-2"
              >
                Reserve Table
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;